import {Composition, Folder} from "remotion";
import {
  ModoAutomaticoEP01, EP01_TOTAL_FRAMES,
  ModoAutoEP01_BR01, ModoAutoEP01_BR02, ModoAutoEP01_BR03,
  ModoAutoEP01_BR04, ModoAutoEP01_BR05, ModoAutoEP01_BR06,
  ModoAutoEP01_BR07, ModoAutoEP01_BR08, ModoAutoEP01_BR09,
  ModoAutoEP01_BR10, ModoAutoEP01_BR11, ModoAutoEP01_BR12,
  ModoAutoEP01_BR13, ModoAutoEP01_BR14,
} from "./compositions/ModoAutomaticoEP01";
import {ModoAutomaticoEP01v3, MODO_AUTO_EP01_V3_TOTAL} from "./compositions/ModoAutomaticoEP01v3";
import {TextReel, calcTextReelTotal} from "./compositions/TextReel";
import {POST_REELS} from "./compositions/postData";
import {ContentOsAgentsV4Glass, BEAT as V4_BEAT} from "./ContentOsAgentsV4Glass";
import {CafeROIIntro} from "./CafeROIIntro";

// Compositions
import {ShowcaseComposition} from "./compositions/Showcase";
import {ContentOsFM01Test, FM01_TOTAL} from "./compositions/ContentOsFM01Test";
import {ContentOsFM01v5} from "./compositions/ContentOsFM01v5";
import {ContentOsFM01v6} from "./compositions/ContentOsFM01v6";
import {ContentOsAgentsV1, AGENTS_V1_TOTAL} from "./compositions/ContentOsAgentsV1";
import {ContentOsAgentsV3, AGENTS_V3_TOTAL} from "./compositions/ContentOsAgentsV3";

// Social templates
import {TikTokVideo} from "./templates/social/TikTokVideo";
import {InstagramReel} from "./templates/social/InstagramReel";
import {YouTubeShort} from "./templates/social/YouTubeShort";

// Content templates
import {Presentation} from "./templates/content/Presentation";
import {Testimonial} from "./templates/content/Testimonial";

// Promo templates
import {Announcement} from "./templates/promo/Announcement";
import {BeforeAfterDemo} from "./compositions/BeforeAfterDemo";

// Editing templates
import {TalkingHeadEdit} from "./templates/editing/TalkingHeadEdit";
import {PodcastClip} from "./templates/editing/PodcastClip";

// Dimus templates
import {QuizVideo, QUIZ_TOTAL_FRAMES} from "./templates/dimus/QuizVideo/QuizVideo";
import {QUESTION_FPS} from "./templates/dimus/QuizVideo/constants";
import {Verdade06, VERDADE06_TOTAL} from "./compositions/Verdade06";
import {CafeEp08, CAFE_EP08_TOTAL} from "./compositions/CafeEp08";
import {Verdade07, VERDADE07_TOTAL} from "./compositions/Verdade07";
import {Quiz02, QUIZ02_TOTAL} from "./compositions/Quiz02";
import {CafeEp09, CAFE_EP09_TOTAL} from "./compositions/CafeEp09";
import {Aprendi03, APRENDI03_TOTAL} from "./compositions/Aprendi03";
import {CafeEp09New, CAFE_EP09_NEW_TOTAL} from "./compositions/CafeEp09New";
import {Perguntas03, PERGUNTAS03_TOTAL} from "./compositions/Perguntas03";
import {CafeEp10, CAFE_EP10_TOTAL} from "./compositions/CafeEp10";
import {Aprendi04, APRENDI04_TOTAL} from "./compositions/Aprendi04";
import {Aprendi04Rich, APRENDI04_RICH_TOTAL} from "./compositions/Aprendi04Rich";
import {CafeEp11, CAFE_EP11_TOTAL} from "./compositions/CafeEp11";
import {CafeEp11Rich, CAFE_EP11_RICH_TOTAL} from "./compositions/CafeEp11Rich";
import {CafeEp12, CAFE_EP12_TOTAL} from "./compositions/CafeEp12";
import {Verdade08, VERDADE08_TOTAL} from "./compositions/Verdade08";
import {Perguntas04, PERGUNTAS04_TOTAL} from "./compositions/Perguntas04";
import {CafeEp13, CAFE_EP13_TOTAL} from "./compositions/CafeEp13";
import {CafeEp14, CAFE_EP14_TOTAL} from "./compositions/CafeEp14";
import {CafeEp20, CAFE_EP20_TOTAL} from "./compositions/CafeEp20";
import {Verdades09, VERDADES09_TOTAL} from "./compositions/Verdades09";
import {ContentReel, contentReelSchema, calcContentReelDuration} from "./compositions/ContentReel";
import {CafeReel, cafeReelSchema} from "./compositions/CafeReel";
import {VerdadesReel, verdadesReelSchema} from "./compositions/VerdadesReel";
import {CarrosselSistemaMarketing} from "./compositions/CarrosselSistemaMarketing";

// 9 carrossel vídeos (1 por slide)
import {Video01Hook} from "./compositions/carrossel/Video01Hook";
import {Video02DadoAncora} from "./compositions/carrossel/Video02DadoAncora";
import {Video03Sinal1} from "./compositions/carrossel/Video03Sinal1";
import {Video04Sinal2} from "./compositions/carrossel/Video04Sinal2";
import {Video05DadoChave} from "./compositions/carrossel/Video05DadoChave";
import {Video06Revelacao} from "./compositions/carrossel/Video06Revelacao";
import {Video07Sinal5} from "./compositions/carrossel/Video07Sinal5";
import {Video08Resolucao} from "./compositions/carrossel/Video08Resolucao";
import {Video09CTA} from "./compositions/carrossel/Video09CTA";

// IA AGENCIAS carrossel (9 vídeos)
import {IA01Hook} from "./compositions/carrossel/IA01Hook";
import {IAA02Dado} from "./compositions/carrossel/IAA02Dado";
import {IAA03Sinal1} from "./compositions/carrossel/IAA03Sinal1";
import {IAA04Sinal2} from "./compositions/carrossel/IAA04Sinal2";
import {IAA05DadoChave} from "./compositions/carrossel/IAA05DadoChave";
import {IAA06Revelacao} from "./compositions/carrossel/IAA06Revelacao";
import {IAA07Pilares} from "./compositions/carrossel/IAA07Pilares";
import {IAA08Resolucao} from "./compositions/carrossel/IAA08Resolucao";
import {IAA09CTA} from "./compositions/carrossel/IAA09CTA";

// MARKETING PREDITIVO carrossel (9 vídeos)
import {MP01Hook} from "./compositions/carrossel/MP01Hook";
import {MP02Dado} from "./compositions/carrossel/MP02Dado";
import {MP03Sinal1} from "./compositions/carrossel/MP03Sinal1";
import {MP04Sinal2} from "./compositions/carrossel/MP04Sinal2";
import {MP05DadoChave} from "./compositions/carrossel/MP05DadoChave";
import {MP06Revelacao} from "./compositions/carrossel/MP06Revelacao";
import {MP07Pilares} from "./compositions/carrossel/MP07Pilares";
import {MP08Resolucao} from "./compositions/carrossel/MP08Resolucao";
import {MP09CTA} from "./compositions/carrossel/MP09CTA";
// CONTENT OS carrossel (10 videos)
import {OS01Hook} from "./compositions/carrossel/OS01Hook";
import {OS02DadoAncora} from "./compositions/carrossel/OS02DadoAncora";
import {OS03TerminalCheck} from "./compositions/carrossel/OS03TerminalCheck";
import {OS04RazaoReal} from "./compositions/carrossel/OS04RazaoReal";
import {OS05OShift} from "./compositions/carrossel/OS05OShift";
import {OS06ContentOS} from "./compositions/carrossel/OS06ContentOS";
import {OS07AVirada} from "./compositions/carrossel/OS07AVirada";
import {OS08ChecklistProblema} from "./compositions/carrossel/OS08ChecklistProblema";
import {OS09AProva} from "./compositions/carrossel/OS09AProva";
import {OS10CTA} from "./compositions/carrossel/OS10CTA";
import { DemoReel } from "./DemoReel";
import { ContentOsV4DarkReel } from "./ContentOsV4DarkReel";
import { ContentOsV4GlassReel } from "./ContentOsV4GlassReel";
import { ContentOsV4PaperReel } from "./ContentOsV4PaperReel";
import { ContentOsV4WarmReel } from "./ContentOsV4WarmReel";
import { ContentOsV4ForbiddenReel } from "./ContentOsV4ForbiddenReel";

import {ContentCaptionSyncDemo, CAPTION_DEMO_TOTAL} from "./compositions/ContentCaptionSyncDemo";
// --- BEGIN VFX TEMPLATES (auto-generated) ---
import AudioSpectrumCircularLoop from "./templates/vfx/audio_spectrum_circular_loop";
import AudioWaveformBarsSyncLoop from "./templates/vfx/audio_waveform-bars_sync_loop";
import BgAuroraWavesColorfulLoop from "./templates/vfx/bg_aurora-waves_colorful_loop";
import BgBlobGradientSoftLoop from "./templates/vfx/bg_blob-gradient_soft_loop";
import BgBokehDepthCirclesLoop from "./templates/vfx/bg_bokeh-depth_circles_loop";
import BgDarkPremiumRadialGlowLoop from "./templates/vfx/bg_dark-premium_radial-glow_loop";
import BgGradientShiftPremiumLoop from "./templates/vfx/bg_gradient-shift_premium_loop";
import BgGridPatternSubtleLoop from "./templates/vfx/bg_grid-pattern_subtle_loop";
import BgMatrixRainCodeLoop from "./templates/vfx/bg_matrix-rain_code_loop";
import BgMeshGradientPastelLoop from "./templates/vfx/bg_mesh-gradient_pastel_loop";
import BgParticleFieldDotsLoop from "./templates/vfx/bg_particle-field_dots_loop";
import BgSemanticGlowDarkLoop from "./templates/vfx/bg_semantic-glow_dark_loop";
import CardAchievementBadgeUnlock700ms from "./templates/vfx/card_achievement-badge_unlock_700ms";
import CardIphoneMockupAppReveal1000ms from "./templates/vfx/card_iphone-mockup_app-reveal_1000ms";
import CardPricingTableTierHighlight1000ms from "./templates/vfx/card_pricing-table_tier-highlight_1000ms";
import CardQuoteFlyoutAuthorTag700ms from "./templates/vfx/card_quote-flyout_author-tag_700ms";
import CardStatsTrioCounterCards1200ms from "./templates/vfx/card_stats-trio_counter-cards_1200ms";
import CardTestimonialQuoteCard900ms from "./templates/vfx/card_testimonial_quote-card_900ms";
import CtaChapterTitleCard1000ms from "./templates/vfx/cta_chapter-title_card_1000ms";
import CtaCinematicTitleLetterbox1200ms from "./templates/vfx/cta_cinematic-title_letterbox_1200ms";
import CtaCountdownTimerRing3000ms from "./templates/vfx/cta_countdown-timer_ring_3000ms";
import CtaSubscribeBellOutro2000ms from "./templates/vfx/cta_subscribe-bell_outro_2000ms";
import DataBarChartRaceAnimatedLoop from "./templates/vfx/data_bar-chart-race_animated_loop";
import DataBarChartReveal1200ms from "./templates/vfx/data_bar-chart_reveal_1200ms";
import DataCounterScale2000ms from "./templates/vfx/data_counter_scale_2000ms";
import DataDonutChartProgress1200ms from "./templates/vfx/data_donut-chart_progress_1200ms";
import DataDonutRevealPercentage800ms from "./templates/vfx/data_donut-reveal_percentage_800ms";
import DataHeatmapGridGlowLoop from "./templates/vfx/data_heatmap_grid-glow_loop";
import DataOdometerCounterStat1500ms from "./templates/vfx/data_odometer-counter_stat_1500ms";
import DataProgressBarSmooth1000ms from "./templates/vfx/data_progress-bar_smooth_1000ms";
import DataProgressRingPercentage1200ms from "./templates/vfx/data_progress-ring_percentage_1200ms";
import DataSparklineTrendLineLoop from "./templates/vfx/data_sparkline_trend-line_loop";
import DataStatCounterHeroAnimated1200ms from "./templates/vfx/data_stat-counter-hero_animated_1200ms";
import FxAnamorphicStreakHorizontal800ms from "./templates/vfx/fx_anamorphic-streak_horizontal_800ms";
import FxBokehHeartsFloat2000ms from "./templates/vfx/fx_bokeh-hearts_float_2000ms";
import FxChromaticAberrationRgbShiftLoop from "./templates/vfx/fx_chromatic-aberration_rgb-shift_loop";
import FxDustParticlesFloatLoop from "./templates/vfx/fx_dust-particles_float_loop";
import FxDustGoldenMotesLoop from "./templates/vfx/fx_dust_golden-motes_loop";
import FxGlitchDatamosh600ms from "./templates/vfx/fx_glitch_datamosh_600ms";
import FxHeatHazeDistortionLoop from "./templates/vfx/fx_heat-haze_distortion_loop";
import FxInkBleedReveal800ms from "./templates/vfx/fx_ink-bleed_reveal_800ms";
import FxLensFlareBurst600ms from "./templates/vfx/fx_lens-flare_burst_600ms";
import FxLightLeakBohoOrange1500ms from "./templates/vfx/fx_light-leak_boho-orange_1500ms";
import FxNeonPulseCyberpunkLoop from "./templates/vfx/fx_neon-pulse_cyberpunk_loop";
import FxRainWindowStreaksLoop from "./templates/vfx/fx_rain_window-streaks_loop";
import FxSmokeAtmosphericDrift3000ms from "./templates/vfx/fx_smoke_atmospheric-drift_3000ms";
import FxSnowCinematicDriftLoop from "./templates/vfx/fx_snow_cinematic-drift_loop";
import FxSpeedLinesZoomBurst400ms from "./templates/vfx/fx_speed-lines_zoom-burst_400ms";
import FxTapeBurnEdgeReveal1000ms from "./templates/vfx/fx_tape-burn_edge-reveal_1000ms";
import FxVhsTrackingGlitch1200ms from "./templates/vfx/fx_vhs-tracking_glitch_1200ms";
import FxVignettePulseHeartbeat1000ms from "./templates/vfx/fx_vignette-pulse_heartbeat_1000ms";
import FxWatercolorInkReveal1200ms from "./templates/vfx/fx_watercolor-ink_reveal_1200ms";
import IconPopBounce300ms from "./templates/vfx/icon_pop_bounce_300ms";
import IgCarouselArrowSwipeHintLoop from "./templates/vfx/ig_carousel-arrow_swipe-hint_loop";
import IgCollabTagProfileBadge500ms from "./templates/vfx/ig_collab-tag_profile-badge_500ms";
import IgPollStickerAnimated1000ms from "./templates/vfx/ig_poll-sticker_animated_1000ms";
import IgReelHookTextOverlay600ms from "./templates/vfx/ig_reel-hook_text-overlay_600ms";
import IgSaveReminderBookmarkPop800ms from "./templates/vfx/ig_save-reminder_bookmark-pop_800ms";
import IgStoryPollVoteBarLoop from "./templates/vfx/ig_story-poll_vote-bar_loop";
import IgSwipeUpArrowBounce2000ms from "./templates/vfx/ig_swipe-up_arrow-bounce_2000ms";
import IntroGlitchLogoReveal1000ms from "./templates/vfx/intro_glitch-logo_reveal_1000ms";
import IntroParticlesGatherForm1500ms from "./templates/vfx/intro_particles-gather_form_1500ms";
import LowerBroadcastLShape600ms from "./templates/vfx/lower_broadcast_l-shape_600ms";
import LowerGlassCardFrosted600ms from "./templates/vfx/lower_glass-card_frosted_600ms";
import LowerInstagramHandleSpring600ms from "./templates/vfx/lower_instagram-handle_spring_600ms";
import LowerMinimalLineDocumentary1500ms from "./templates/vfx/lower_minimal-line_documentary_1500ms";
import LowerMrbeastStyleBold2000ms from "./templates/vfx/lower_mrbeast-style_bold_2000ms";
import LowerPillSocialHandle500ms from "./templates/vfx/lower_pill_social-handle_500ms";
import OutroSubscribeEndcardCta3000ms from "./templates/vfx/outro_subscribe-endcard_cta_3000ms";
import OverlayGrainFilmLoop from "./templates/vfx/overlay_grain_film_loop";
import OverlayLightLeakCinematicLoop from "./templates/vfx/overlay_light-leak_cinematic_loop";
import OverlayVignetteDarkStatic from "./templates/vfx/overlay_vignette_dark_static";
import Text3dFlipDepartureBoard400ms from "./templates/vfx/text_3d-flip_departure-board_400ms";
import TextFadeUpMinimal500ms from "./templates/vfx/text_fade-up_minimal_500ms";
import TextGlitchRevealCyberpunk800ms from "./templates/vfx/text_glitch-reveal_cyberpunk_800ms";
import TextGradientTextAnimatedLoop from "./templates/vfx/text_gradient-text_animated_loop";
import TextHighlightRevealWord700ms from "./templates/vfx/text_highlight-reveal_word_700ms";
import TextHormoziCaptionBoldPop800ms from "./templates/vfx/text_hormozi-caption_bold-pop_800ms";
import TextKaraokeColorSweepLoop from "./templates/vfx/text_karaoke_color-sweep_loop";
import TextKineticWordPunch1000ms from "./templates/vfx/text_kinetic_word-punch_1000ms";
import TextMorphingWordsTransform800ms from "./templates/vfx/text_morphing-words_transform_800ms";
import TextNeonGlowWordAppear500ms from "./templates/vfx/text_neon-glow_word-appear_500ms";
import TextRedactedRevealCensored700ms from "./templates/vfx/text_redacted-reveal_censored_700ms";
import TextScrambleDecodeTechno1200ms from "./templates/vfx/text_scramble-decode_techno_1200ms";
import TextSlideUpMaskedClip500ms from "./templates/vfx/text_slide-up-masked_clip_500ms";
import TextStampInImpact300ms from "./templates/vfx/text_stamp-in_impact_300ms";
import TextSubtitleBarSentenceFade800ms from "./templates/vfx/text_subtitle-bar_sentence-fade_800ms";
import TextTrackingExpandReveal600ms from "./templates/vfx/text_tracking-expand_reveal_600ms";
import TextTypewriterCursor2000ms from "./templates/vfx/text_typewriter_cursor_2000ms";
import TextWaveCharsUndulateLoop from "./templates/vfx/text_wave-chars_undulate_loop";
import TextWordStaggerSpring800ms from "./templates/vfx/text_word-stagger_spring_800ms";
import TransitionBarnDoorHorizontal500ms from "./templates/vfx/transition_barn-door_horizontal_500ms";
import TransitionFlashWhiteImpact180ms from "./templates/vfx/transition_flash-white_impact_180ms";
import TransitionIrisCircleReveal500ms from "./templates/vfx/transition_iris-circle_reveal_500ms";
import TransitionLightLeakWarm800ms from "./templates/vfx/transition_light-leak_warm_800ms";
import TransitionMorphColorSmooth500ms from "./templates/vfx/transition_morph-color_smooth_500ms";
import TransitionRgbSplitGlitch300ms from "./templates/vfx/transition_rgb-split_glitch_300ms";
import TransitionSlideLeftSmooth300ms from "./templates/vfx/transition_slide-left_smooth_300ms";
import TransitionSpin360Fast400ms from "./templates/vfx/transition_spin-360_fast_400ms";
import TransitionWhipPanFast250ms from "./templates/vfx/transition_whip-pan_fast_250ms";
import TransitionZoomPunchSnappy200ms from "./templates/vfx/transition_zoom-punch_snappy_200ms";
import UiBeforeAfterSplit1000ms from "./templates/vfx/ui_before-after_split_1000ms";
import UiCalloutBoxDraw800ms from "./templates/vfx/ui_callout-box_draw_800ms";
import UiCardGlassPremium600ms from "./templates/vfx/ui_card-glass_premium_600ms";
import UiChecklistCascade900ms from "./templates/vfx/ui_checklist_cascade_900ms";
import UiComparisonSplitCards1000ms from "./templates/vfx/ui_comparison-split_cards_1000ms";
import UiCtaTripleCardsCascade1000ms from "./templates/vfx/ui_cta-triple-cards_cascade_1000ms";
import UiEpisodePillBranded300ms from "./templates/vfx/ui_episode-pill_branded_300ms";
import UiFeatureListStagger900ms from "./templates/vfx/ui_feature-list_stagger_900ms";
import UiFloatingBadgeAlert600ms from "./templates/vfx/ui_floating-badge_alert_600ms";
import UiMacWindowMockup800ms from "./templates/vfx/ui_mac-window_mockup_800ms";
import UiNetworkGraphAnimated1500ms from "./templates/vfx/ui_network-graph_animated_1500ms";
import UiNotificationToastStack800ms from "./templates/vfx/ui_notification-toast_stack_800ms";
import UiStatCardImpact800ms from "./templates/vfx/ui_stat-card_impact_800ms";
import UiStoryProgressBarsLoop from "./templates/vfx/ui_story-progress_bars_loop";
import UiTerminalBlockTypewriter1500ms from "./templates/vfx/ui_terminal-block_typewriter_1500ms";
// --- END VFX TEMPLATES (auto-generated) ---

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Folder name="Examples">
        <Composition
          id="Showcase"
          component={ShowcaseComposition}
          durationInFrames={300}
          fps={30}
          width={1920}
          height={1080}
        />
      </Folder>

      <Folder name="Social">
        <Composition
          id="TikTok"
          component={TikTokVideo}
          durationInFrames={270}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{
            hook: "Did you know this?",
            body: "AI can edit videos now using just code.",
            cta: "Follow for more",
          }}
        />
        <Composition
          id="InstagramReel"
          component={InstagramReel}
          durationInFrames={240}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{
            headline: "Your headline here",
            subtext: "Supporting text goes here",
            brandName: "Brand",
          }}
        />
        <Composition
          id="YouTubeShort"
          component={YouTubeShort}
          durationInFrames={300}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{
            title: "Your Title Here",
            subtitle: "Subtitle goes here",
          }}
        />
      </Folder>

      <Folder name="Content">
        <Composition
          id="Presentation"
          component={Presentation}
          durationInFrames={450}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            slides: [
              {title: "Welcome", body: "This is slide one"},
              {title: "The Problem", body: "Here's what we're solving"},
              {title: "The Solution", body: "Here's how we solve it"},
            ],
          }}
        />
        <Composition
          id="Testimonial"
          component={Testimonial}
          durationInFrames={180}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            quote:
              "This product completely changed how we work. Highly recommended.",
            author: "Jane Doe",
            role: "CEO at Company",
          }}
        />
      </Folder>

      <Folder name="Promo">
        <Composition
          id="Announcement"
          component={Announcement}
          durationInFrames={300}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            preTitle: "Introducing",
            title: "Something Amazing",
            subtitle: "The future is here",
            cta: "Learn More",
          }}
        />
        <Composition
          id="BeforeAfter"
          component={BeforeAfterDemo}
          durationInFrames={180}
          fps={30}
          width={1920}
          height={1080}
        />
      </Folder>

      <Folder name="Editing">
        <Composition
          id="TalkingHeadEdit"
          component={TalkingHeadEdit}
          durationInFrames={900}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            videoSrc: "assets/video.mp4",
            showCaptions: true,
            captionPreset: "bold" as const,
            removeSilence: false,
          }}
        />
        <Composition
          id="PodcastClip"
          component={PodcastClip}
          durationInFrames={900}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{
            videoSrc: "assets/video.mp4",
            clipStartSeconds: 0,
            clipEndSeconds: 30,
            showCaptions: true,
            captionPreset: "bold" as const,
          }}
        />
      </Folder>

      <Folder name="Dimus">
        <Composition
          id="QuizVideo"
          component={QuizVideo}
          durationInFrames={QUIZ_TOTAL_FRAMES}
          fps={QUESTION_FPS}
          width={1080}
          height={1920}
        />
        <Composition
          id="Verdade06-GlitchRevelation"
          component={Verdade06}
          durationInFrames={VERDADE06_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp08-3NumerosDono"
          component={CafeEp08}
          durationInFrames={CAFE_EP08_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Verdade07-DonoGargalo"
          component={Verdade07}
          durationInFrames={VERDADE07_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Quiz02-Growth"
          component={Quiz02}
          durationInFrames={QUIZ02_TOTAL}
          fps={60}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp09-RelatorioBonito"
          component={CafeEp09}
          durationInFrames={CAFE_EP09_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Aprendi03-OverDelivery"
          component={Aprendi03}
          durationInFrames={APRENDI03_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Perguntas03-CustoNaoInvestir"
          component={Perguntas03}
          durationInFrames={PERGUNTAS03_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp09-CaroOuBarato"
          component={CafeEp09New}
          durationInFrames={CAFE_EP09_NEW_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp10-TempoAtePagamento"
          component={CafeEp10}
          durationInFrames={CAFE_EP10_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp11-ClienteReclama"
          component={CafeEp11}
          durationInFrames={CAFE_EP11_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp11Rich-ClienteReclama"
          component={CafeEp11Rich}
          durationInFrames={CAFE_EP11_RICH_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Perguntas04-TempoLead"
          component={Perguntas04}
          durationInFrames={PERGUNTAS04_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Verdade08-Sumisse30Dias"
          component={Verdade08}
          durationInFrames={VERDADE08_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp12-ProblemaDeOrdem"
          component={CafeEp12}
          durationInFrames={CAFE_EP12_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Aprendi04-IgnoreiNumeros"
          component={Aprendi04}
          durationInFrames={APRENDI04_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="Aprendi04Rich-IgnoreiNumeros"
          component={Aprendi04Rich}
          durationInFrames={APRENDI04_RICH_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp13-ProcessoInvisivel"
          component={CafeEp13}
          durationInFrames={CAFE_EP13_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp14-APrisaoDoDono"
          component={CafeEp14}
          durationInFrames={CAFE_EP14_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="ContentReel"
          component={ContentReel}
          schema={contentReelSchema}
          fps={30}
          width={1080}
          height={1920}
          durationInFrames={900}
          defaultProps={{scenes:[],bgm:"music/cafe-lofi.mp3",bgmVolume:0.12,ttsVolume:0.95}}
          calculateMetadata={({props}:any)=>({durationInFrames: props.scenes && props.scenes.length ? calcContentReelDuration(props.scenes) : 900})}
        />
        <Composition
          id="CafeReel"
          component={CafeReel}
          schema={cafeReelSchema}
          fps={30}
          width={1080}
          height={1920}
          durationInFrames={900}
          defaultProps={{scenes:[],bgm:"music/cafe-lofi.mp3",bgmVolume:0.12,ttsVolume:0.95}}
          calculateMetadata={({props}:any)=>({durationInFrames: props.scenes && props.scenes.length ? props.scenes.reduce((a:number,s:any)=>a+s.durFrames,0) + (props.scenes.length-1)*20 : 900})}
        />
        <Composition
          id="VerdadesReel"
          component={VerdadesReel}
          schema={verdadesReelSchema}
          fps={30}
          width={1080}
          height={1920}
          durationInFrames={900}
          defaultProps={{scenes:[],bgm:"music/cafe-lofi.mp3",bgmVolume:0.10,ttsVolume:0.95}}
          calculateMetadata={({props}:any)=>({durationInFrames: props.scenes && props.scenes.length ? props.scenes.reduce((a:number,s:any)=>a+s.durFrames,0) + (props.scenes.length-1)*18 : 900})}
        />
        <Composition
          id="Verdades09-BriefingRuim"
          component={Verdades09}
          durationInFrames={VERDADES09_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
        <Composition
          id="CafeEp20-CACBlended"
          component={CafeEp20}
          durationInFrames={CAFE_EP20_TOTAL}
          fps={30}
          width={1080}
          height={1920}
        />
      
        <Composition
          id="DemoReel"
          component={DemoReel}
          durationInFrames={1956}
          fps={30}
          width={1080}
          height={1920}
        />

        <Composition
          id="ContentOsV4DarkReel"
          component={ContentOsV4DarkReel}
          durationInFrames={2297}
          fps={30}
          width={1080}
          height={1920}
        />

        <Composition
          id="ContentOsV4GlassReel"
          component={ContentOsV4GlassReel}
          durationInFrames={1956}
          fps={30}
          width={1080}
          height={1920}
        />

        <Composition
          id="ContentOsV4PaperReel"
          component={ContentOsV4PaperReel}
          durationInFrames={3330}
          fps={30}
          width={1080}
          height={1920}
        />

        <Composition
          id="ContentOsV4WarmReel"
          component={ContentOsV4WarmReel}
          durationInFrames={2984}
          fps={30}
          width={1080}
          height={1920}
        />

        <Composition
          id="ContentOsV4ForbiddenReel"
          component={ContentOsV4ForbiddenReel}
          durationInFrames={1639}
          fps={30}
          width={1080}
          height={1920}
        />
</Folder>
      <Composition
        id="Carrossel-SistemaMarketing"
        component={CarrosselSistemaMarketing}
        durationInFrames={2700}
        fps={30}
        width={720}
        height={900}
      />
      {/* 9 CARROSSEL VÍDEOS — SISTEMA DE MARKETING */}
      <Composition
        id="Carrossel-V01-Hook"
        component={Video01Hook}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V02-DadoAncora"
        component={Video02DadoAncora}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V03-Sinal1"
        component={Video03Sinal1}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V04-Sinal2"
        component={Video04Sinal2}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V05-DadoChave"
        component={Video05DadoChave}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V06-Revelacao"
        component={Video06Revelacao}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V07-Sinal5"
        component={Video07Sinal5}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V08-Resolucao"
        component={Video08Resolucao}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />
      <Composition
        id="Carrossel-V09-CTA"
        component={Video09CTA}
        durationInFrames={300}
        fps={30}
        width={720}
        height={900}
      />

      {/* IA AGENCIAS carrossel (9 vídeos) */}
      <Composition id="IA01Hook" component={IA01Hook} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA02Dado" component={IAA02Dado} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA03Sinal1" component={IAA03Sinal1} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA04Sinal2" component={IAA04Sinal2} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA05DadoChave" component={IAA05DadoChave} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA06Revelacao" component={IAA06Revelacao} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA07Pilares" component={IAA07Pilares} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA08Resolucao" component={IAA08Resolucao} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="IAA09CTA" component={IAA09CTA} durationInFrames={300} fps={30} width={720} height={900} />

      {/* MARKETING PREDITIVO carrossel (9 vídeos) */}
      <Composition id="MP01Hook" component={MP01Hook} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP02Dado" component={MP02Dado} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP03Sinal1" component={MP03Sinal1} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP04Sinal2" component={MP04Sinal2} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP05DadoChave" component={MP05DadoChave} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP06Revelacao" component={MP06Revelacao} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP07Pilares" component={MP07Pilares} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP08Resolucao" component={MP08Resolucao} durationInFrames={300} fps={30} width={720} height={900} />
      <Composition id="MP09CTA" component={MP09CTA} durationInFrames={300} fps={30} width={720} height={900} />

      {/* CONTENT OS carrossel (10 videos) */}
      <Folder name="Carrossel-OS">
        <Composition id="OS01Hook" component={OS01Hook} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS02DadoAncora" component={OS02DadoAncora} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS03TerminalCheck" component={OS03TerminalCheck} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS04RazaoReal" component={OS04RazaoReal} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS05OShift" component={OS05OShift} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS06ContentOS" component={OS06ContentOS} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS07AVirada" component={OS07AVirada} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS08ChecklistProblema" component={OS08ChecklistProblema} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS09AProva" component={OS09AProva} durationInFrames={300} fps={30} width={720} height={900} />
        <Composition id="OS10CTA" component={OS10CTA} durationInFrames={300} fps={30} width={720} height={900} />
      </Folder>

      {/* FM-01 — Content OS Zero-Narration Test */}
      <Composition
        id="ContentOsFM01Test"
        component={ContentOsFM01Test}
        durationInFrames={FM01_TOTAL}
        fps={30}
        width={720}
        height={1280}
        defaultProps={{}}
      />
      {/* FM-01 v6: editorial thinking visuals + ElevenLabs voice over */}
      <Composition
        id="ContentOsAgentsV1"
        component={ContentOsAgentsV1}
        durationInFrames={AGENTS_V1_TOTAL}
        fps={30}
        width={720}
        height={1280}
      />
            {/* Agents V3 — Build While You Sleep | New BGs + Burned-in Captions */}
      <Composition
        id="ContentOsAgentsV3"
        component={ContentOsAgentsV3}
        durationInFrames={AGENTS_V3_TOTAL}
        fps={30}
        width={720}
        height={1280}
      />
      {/* Agents V1 — Build While You Sleep | VO-FIRST 23.3s */}
      <Composition
        id="ContentOsFM01v6"
        component={ContentOsFM01v6}
        durationInFrames={1380}
        fps={30}
        width={720}
        height={1280}
      />
      {/* FM-01 v5 — TerminalCard + FlowStep + StatsCard visual elements */}
      <Composition
        id="ContentOsFM01v5"
        component={ContentOsFM01v5}
        durationInFrames={1380}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="ContentOsAgentsV4Glass"
        component={ContentOsAgentsV4Glass}
        durationInFrames={1350}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CafeROIIntro"
        component={CafeROIIntro}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* ── TextReel — May 16-20, 2026 (20 posts) ── */}
      {POST_REELS.map((pr) => (
        <Composition
          key={pr.compositionId}
          id={pr.compositionId}
          component={TextReel as React.ComponentType<any>}
          durationInFrames={calcTextReelTotal(pr.lines)}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{
            lines: pr.lines,
            style: pr.style,
            badge: pr.badge,
          }}
        />
      ))}

      {/* ── MODO AUTOMÁTICO EP01 — B-rolls + Assembly ── */}
      <Folder name="ModoAutomatico-EP01">
        <Composition id="ModoAutoEP01" component={ModoAutomaticoEP01 as React.ComponentType<any>}
          durationInFrames={EP01_TOTAL_FRAMES} fps={60} width={1080} height={1920}
          defaultProps={{arollPath: "aroll/ep01_aroll.mp4"}} />
        <Composition id="ModoAutoEP01-BR01" component={ModoAutoEP01_BR01}
          durationInFrames={180} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR02" component={ModoAutoEP01_BR02}
          durationInFrames={150} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR03" component={ModoAutoEP01_BR03}
          durationInFrames={180} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR04" component={ModoAutoEP01_BR04}
          durationInFrames={240} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR05" component={ModoAutoEP01_BR05}
          durationInFrames={240} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR06" component={ModoAutoEP01_BR06}
          durationInFrames={210} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR07" component={ModoAutoEP01_BR07}
          durationInFrames={210} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR08" component={ModoAutoEP01_BR08}
          durationInFrames={180} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR09" component={ModoAutoEP01_BR09}
          durationInFrames={180} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR10" component={ModoAutoEP01_BR10}
          durationInFrames={240} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR11" component={ModoAutoEP01_BR11}
          durationInFrames={180} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR12" component={ModoAutoEP01_BR12}
          durationInFrames={240} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR13" component={ModoAutoEP01_BR13}
          durationInFrames={240} fps={60} width={1080} height={1920} />
        <Composition id="ModoAutoEP01-BR14" component={ModoAutoEP01_BR14}
          durationInFrames={360} fps={60} width={1080} height={1920} />
      </Folder>
      <Composition
        id="ModoAutoEP01v3"
        component={ModoAutomaticoEP01v3}
        durationInFrames={MODO_AUTO_EP01_V3_TOTAL}
        fps={30}
        width={1080}
        height={1920}
      />
    {/* --- BEGIN VFX COMPOSITIONS (auto-generated) --- */}
      <Composition
        id="AudioSpectrumCircularLoop"
        component={AudioSpectrumCircularLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="AudioWaveformBarsSyncLoop"
        component={AudioWaveformBarsSyncLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="BgAuroraWavesColorfulLoop"
        component={BgAuroraWavesColorfulLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgBlobGradientSoftLoop"
        component={BgBlobGradientSoftLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgBokehDepthCirclesLoop"
        component={BgBokehDepthCirclesLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="BgDarkPremiumRadialGlowLoop"
        component={BgDarkPremiumRadialGlowLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgGradientShiftPremiumLoop"
        component={BgGradientShiftPremiumLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="BgGridPatternSubtleLoop"
        component={BgGridPatternSubtleLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgMatrixRainCodeLoop"
        component={BgMatrixRainCodeLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="BgMeshGradientPastelLoop"
        component={BgMeshGradientPastelLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgParticleFieldDotsLoop"
        component={BgParticleFieldDotsLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="BgSemanticGlowDarkLoop"
        component={BgSemanticGlowDarkLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="CardAchievementBadgeUnlock700ms"
        component={CardAchievementBadgeUnlock700ms}
        durationInFrames={21}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CardIphoneMockupAppReveal1000ms"
        component={CardIphoneMockupAppReveal1000ms}
        durationInFrames={30}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CardPricingTableTierHighlight1000ms"
        component={CardPricingTableTierHighlight1000ms}
        durationInFrames={30}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CardQuoteFlyoutAuthorTag700ms"
        component={CardQuoteFlyoutAuthorTag700ms}
        durationInFrames={21}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CardStatsTrioCounterCards1200ms"
        component={CardStatsTrioCounterCards1200ms}
        durationInFrames={36}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CardTestimonialQuoteCard900ms"
        component={CardTestimonialQuoteCard900ms}
        durationInFrames={27}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CtaChapterTitleCard1000ms"
        component={CtaChapterTitleCard1000ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CtaCinematicTitleLetterbox1200ms"
        component={CtaCinematicTitleLetterbox1200ms}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="CtaCountdownTimerRing3000ms"
        component={CtaCountdownTimerRing3000ms}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CtaSubscribeBellOutro2000ms"
        component={CtaSubscribeBellOutro2000ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataBarChartRaceAnimatedLoop"
        component={DataBarChartRaceAnimatedLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataBarChartReveal1200ms"
        component={DataBarChartReveal1200ms}
        durationInFrames={36}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="DataCounterScale2000ms"
        component={DataCounterScale2000ms}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataDonutChartProgress1200ms"
        component={DataDonutChartProgress1200ms}
        durationInFrames={36}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="DataDonutRevealPercentage800ms"
        component={DataDonutRevealPercentage800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataHeatmapGridGlowLoop"
        component={DataHeatmapGridGlowLoop}
        durationInFrames={75}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataOdometerCounterStat1500ms"
        component={DataOdometerCounterStat1500ms}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataProgressBarSmooth1000ms"
        component={DataProgressBarSmooth1000ms}
        durationInFrames={30}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="DataProgressRingPercentage1200ms"
        component={DataProgressRingPercentage1200ms}
        durationInFrames={36}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataSparklineTrendLineLoop"
        component={DataSparklineTrendLineLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="DataStatCounterHeroAnimated1200ms"
        component={DataStatCounterHeroAnimated1200ms}
        durationInFrames={36}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxAnamorphicStreakHorizontal800ms"
        component={FxAnamorphicStreakHorizontal800ms}
        durationInFrames={48}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxBokehHeartsFloat2000ms"
        component={FxBokehHeartsFloat2000ms}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxChromaticAberrationRgbShiftLoop"
        component={FxChromaticAberrationRgbShiftLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxDustParticlesFloatLoop"
        component={FxDustParticlesFloatLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxDustGoldenMotesLoop"
        component={FxDustGoldenMotesLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxGlitchDatamosh600ms"
        component={FxGlitchDatamosh600ms}
        durationInFrames={36}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxHeatHazeDistortionLoop"
        component={FxHeatHazeDistortionLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxInkBleedReveal800ms"
        component={FxInkBleedReveal800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxLensFlareBurst600ms"
        component={FxLensFlareBurst600ms}
        durationInFrames={36}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxLightLeakBohoOrange1500ms"
        component={FxLightLeakBohoOrange1500ms}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxNeonPulseCyberpunkLoop"
        component={FxNeonPulseCyberpunkLoop}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxRainWindowStreaksLoop"
        component={FxRainWindowStreaksLoop}
        durationInFrames={75}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxSmokeAtmosphericDrift3000ms"
        component={FxSmokeAtmosphericDrift3000ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxSnowCinematicDriftLoop"
        component={FxSnowCinematicDriftLoop}
        durationInFrames={120}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxSpeedLinesZoomBurst400ms"
        component={FxSpeedLinesZoomBurst400ms}
        durationInFrames={24}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxTapeBurnEdgeReveal1000ms"
        component={FxTapeBurnEdgeReveal1000ms}
        durationInFrames={60}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxVhsTrackingGlitch1200ms"
        component={FxVhsTrackingGlitch1200ms}
        durationInFrames={36}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxVignettePulseHeartbeat1000ms"
        component={FxVignettePulseHeartbeat1000ms}
        durationInFrames={30}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FxWatercolorInkReveal1200ms"
        component={FxWatercolorInkReveal1200ms}
        durationInFrames={36}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IconPopBounce300ms"
        component={IconPopBounce300ms}
        durationInFrames={9}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgCarouselArrowSwipeHintLoop"
        component={IgCarouselArrowSwipeHintLoop}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgCollabTagProfileBadge500ms"
        component={IgCollabTagProfileBadge500ms}
        durationInFrames={15}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgPollStickerAnimated1000ms"
        component={IgPollStickerAnimated1000ms}
        durationInFrames={30}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgReelHookTextOverlay600ms"
        component={IgReelHookTextOverlay600ms}
        durationInFrames={36}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgSaveReminderBookmarkPop800ms"
        component={IgSaveReminderBookmarkPop800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgStoryPollVoteBarLoop"
        component={IgStoryPollVoteBarLoop}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IgSwipeUpArrowBounce2000ms"
        component={IgSwipeUpArrowBounce2000ms}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IntroGlitchLogoReveal1000ms"
        component={IntroGlitchLogoReveal1000ms}
        durationInFrames={60}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="IntroParticlesGatherForm1500ms"
        component={IntroParticlesGatherForm1500ms}
        durationInFrames={90}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="LowerBroadcastLShape600ms"
        component={LowerBroadcastLShape600ms}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="LowerGlassCardFrosted600ms"
        component={LowerGlassCardFrosted600ms}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="LowerInstagramHandleSpring600ms"
        component={LowerInstagramHandleSpring600ms}
        durationInFrames={18}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="LowerMinimalLineDocumentary1500ms"
        component={LowerMinimalLineDocumentary1500ms}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="LowerMrbeastStyleBold2000ms"
        component={LowerMrbeastStyleBold2000ms}
        durationInFrames={120}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="LowerPillSocialHandle500ms"
        component={LowerPillSocialHandle500ms}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="OutroSubscribeEndcardCta3000ms"
        component={OutroSubscribeEndcardCta3000ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="OverlayGrainFilmLoop"
        component={OverlayGrainFilmLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="OverlayLightLeakCinematicLoop"
        component={OverlayLightLeakCinematicLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="OverlayVignetteDarkStatic"
        component={OverlayVignetteDarkStatic}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="Text3dFlipDepartureBoard400ms"
        component={Text3dFlipDepartureBoard400ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextFadeUpMinimal500ms"
        component={TextFadeUpMinimal500ms}
        durationInFrames={15}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextGlitchRevealCyberpunk800ms"
        component={TextGlitchRevealCyberpunk800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextGradientTextAnimatedLoop"
        component={TextGradientTextAnimatedLoop}
        durationInFrames={90}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TextHighlightRevealWord700ms"
        component={TextHighlightRevealWord700ms}
        durationInFrames={21}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TextHormoziCaptionBoldPop800ms"
        component={TextHormoziCaptionBoldPop800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextKaraokeColorSweepLoop"
        component={TextKaraokeColorSweepLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextKineticWordPunch1000ms"
        component={TextKineticWordPunch1000ms}
        durationInFrames={30}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TextMorphingWordsTransform800ms"
        component={TextMorphingWordsTransform800ms}
        durationInFrames={48}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextNeonGlowWordAppear500ms"
        component={TextNeonGlowWordAppear500ms}
        durationInFrames={45}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextRedactedRevealCensored700ms"
        component={TextRedactedRevealCensored700ms}
        durationInFrames={21}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextScrambleDecodeTechno1200ms"
        component={TextScrambleDecodeTechno1200ms}
        durationInFrames={36}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TextSlideUpMaskedClip500ms"
        component={TextSlideUpMaskedClip500ms}
        durationInFrames={30}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextStampInImpact300ms"
        component={TextStampInImpact300ms}
        durationInFrames={18}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextSubtitleBarSentenceFade800ms"
        component={TextSubtitleBarSentenceFade800ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextTrackingExpandReveal600ms"
        component={TextTrackingExpandReveal600ms}
        durationInFrames={18}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextTypewriterCursor2000ms"
        component={TextTypewriterCursor2000ms}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextWaveCharsUndulateLoop"
        component={TextWaveCharsUndulateLoop}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextWordStaggerSpring800ms"
        component={TextWordStaggerSpring800ms}
        durationInFrames={24}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TransitionBarnDoorHorizontal500ms"
        component={TransitionBarnDoorHorizontal500ms}
        durationInFrames={15}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionFlashWhiteImpact180ms"
        component={TransitionFlashWhiteImpact180ms}
        durationInFrames={5}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionIrisCircleReveal500ms"
        component={TransitionIrisCircleReveal500ms}
        durationInFrames={15}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionLightLeakWarm800ms"
        component={TransitionLightLeakWarm800ms}
        durationInFrames={24}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionMorphColorSmooth500ms"
        component={TransitionMorphColorSmooth500ms}
        durationInFrames={15}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TransitionRgbSplitGlitch300ms"
        component={TransitionRgbSplitGlitch300ms}
        durationInFrames={9}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionSlideLeftSmooth300ms"
        component={TransitionSlideLeftSmooth300ms}
        durationInFrames={9}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionSpin360Fast400ms"
        component={TransitionSpin360Fast400ms}
        durationInFrames={12}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransitionWhipPanFast250ms"
        component={TransitionWhipPanFast250ms}
        durationInFrames={7}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="TransitionZoomPunchSnappy200ms"
        component={TransitionZoomPunchSnappy200ms}
        durationInFrames={6}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiBeforeAfterSplit1000ms"
        component={UiBeforeAfterSplit1000ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="UiCalloutBoxDraw800ms"
        component={UiCalloutBoxDraw800ms}
        durationInFrames={24}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiCardGlassPremium600ms"
        component={UiCardGlassPremium600ms}
        durationInFrames={18}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="UiChecklistCascade900ms"
        component={UiChecklistCascade900ms}
        durationInFrames={27}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiComparisonSplitCards1000ms"
        component={UiComparisonSplitCards1000ms}
        durationInFrames={30}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiCtaTripleCardsCascade1000ms"
        component={UiCtaTripleCardsCascade1000ms}
        durationInFrames={30}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiEpisodePillBranded300ms"
        component={UiEpisodePillBranded300ms}
        durationInFrames={9}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiFeatureListStagger900ms"
        component={UiFeatureListStagger900ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="UiFloatingBadgeAlert600ms"
        component={UiFloatingBadgeAlert600ms}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="UiMacWindowMockup800ms"
        component={UiMacWindowMockup800ms}
        durationInFrames={24}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiNetworkGraphAnimated1500ms"
        component={UiNetworkGraphAnimated1500ms}
        durationInFrames={45}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiNotificationToastStack800ms"
        component={UiNotificationToastStack800ms}
        durationInFrames={24}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiStatCardImpact800ms"
        component={UiStatCardImpact800ms}
        durationInFrames={24}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="UiStoryProgressBarsLoop"
        component={UiStoryProgressBarsLoop}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="UiTerminalBlockTypewriter1500ms"
        component={UiTerminalBlockTypewriter1500ms}
        durationInFrames={45}
        fps={30}
        width={720}
        height={1280}
      />
      <Composition
        id="ContentCaptionSyncDemo"
        component={ContentCaptionSyncDemo}
        durationInFrames={CAPTION_DEMO_TOTAL}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* --- END VFX COMPOSITIONS (auto-generated) --- */}
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
